export const objectFilter = <T extends object>(
  obj: T,
  f: (k: keyof T, v: T[keyof T]) => boolean,
) =>
  Object.fromEntries(
    Object.entries(obj).filter(([k, v]) => f(k as keyof T, v)),
  ) as Partial<T>;

export const objectMap = <R, T extends object>(
  obj: T,
  f: (k: keyof T, v: T[keyof T]) => [typeof k, R],
): Record<string, R> =>
  Object.fromEntries(
    (Object.entries(obj) as [keyof T, T[keyof T]][]).map(([k, v]) => f(k, v)),
  );

export const objectSort = <T extends object>(
  obj: T,
  f: (
    kv1: [k: keyof T, v: T[keyof T]],
    kv2: [k: keyof T, v: T[keyof T]],
  ) => number,
) =>
  Object.fromEntries(
    (Object.entries(obj) as [keyof T, T[keyof T]][]).sort((kv1, kv2) =>
      f(kv1, kv2),
    ),
  ) as T;
